import crazyUber from "./crazyUber/crazyUber";
import winterWizardJam from "./winterWizardJam/winterWizardJam";
import itsAllComeToThis from "./itsAllComeToThis/itsAllComeToThis";
import afterYou from "./afterYou/afterYou";
import zombieScrapyard from "./zombieScrapyard/zombieScrapyard";
import fall from "./fall/fall";
import madScience from "./madScience/madScience";
import scale from "./scale/scale";
import choon from "./choon/choon";
import progger from "./progger/progger";

const games = [
  crazyUber,
  winterWizardJam,
  itsAllComeToThis,
  afterYou,
  zombieScrapyard,
  fall,
  madScience,
  scale,
  choon,
  progger
];
export default games;
